import React from "react";
import { useForm } from 'react-hook-form';
import useTranslations from "../../hooks/useTranslations";
import EmptyState from "../illustrations/EmptyState";
import TemplateFormElementMenu from "./TemplateFormElementMenu";

import { Spacer, Center, VStack, } from "@chakra-ui/react";

type AddTemplateElementButtonProps = React.PropsWithChildren<{
  insideSection: boolean;
  getValues: ReturnType<typeof useForm>["getValues"];
  setValue: ReturnType<typeof useForm>["setValue"];
  fields: any;
  append?: any;
  insert?: any;
  reset?: ReturnType<typeof useForm>["reset"];
  sectionIndex?: number;
  handleFocus: (sectionIndex: number, question: number) => void;
  name: string;
  insertIndex?: number;
}>;

const AddTemplateElementButton: React.FC<AddTemplateElementButtonProps> = ({
  insideSection,
  fields,
  name,
  handleFocus,
  setValue,
  getValues,
  append,
  insert,
  reset,
  sectionIndex,
  insertIndex,
  children
}) => {
  const t = useTranslations();

  return (
    <Center>
      <VStack>
        {fields.length === 0 && <EmptyState />}

        <Spacer />

        <TemplateFormElementMenu
          insideSection={insideSection}
          handleFocus={handleFocus}
          setValue={setValue}
          getValues={getValues}
          fields={fields}
          append={append}
          insert={insert}
          reset={reset}
          name={name}
          sectionIndex={sectionIndex}
          insertIndex={insertIndex}
        >
          {children}
        </TemplateFormElementMenu>
      </VStack>
    </Center>
  );
}

export default AddTemplateElementButton;
